import React from "react";
import { HomePageInitialState, PageNewState } from ".";

export const HomePageContext = React.createContext({
  pageState: HomePageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
